export default (
  state = {
    context: null,
    trackers: null,
    KRIFilters: {},
  },
  action,
) => {
  switch (action.type) {
    case 'COMPOUND_INDICATORS/SET_CONTEXT':
      return {
        ...state,
        context: action.context,
      };

    case 'COMPOUND_INDICATORS/SET_TRACKERS':
      return {
        ...state,
        trackers: action.trackers,
      };

    case 'COMPOUND_INDICATORS/SET_FILTERS':
      return {
        ...state,
        KRIFilters: action.KRIFilters,
      };

    default:
      return state;
  }
};
